class ClickHandlerV2 {
    constructor() {

        document.addEventListener('click', this.handleClick.bind(this));
        document.addEventListener('DOMContentLoaded', this.onload.bind(this));
        this.cartRemoveItem();
    }

    onload() {
        this.checkCartOnLoad()
        this.cartUpdate();
    }

    handleClick(event) {
        this.customATC(event.target);
    }

    cartRemoveItem() {
        window.upcartOnItemRemoved = function(_, item) {
            const itemToUpdate = document.querySelector(`[data-variant-id="${item.id}"] span`); 
            itemToUpdate.innerText = cstmAtcBtnName_xx;
        };
    }

    cartUpdate() {
      window.upcartOnCartUpdated = (cart) => {
        this.cartUpdateItem(cart.items);
      }
    }

    cartUpdateItem(cartItems) {
      cartItems.forEach((cartItem) => {
        const variantId = cartItem.id;
        const cartQuantity = cartItem.quantity;
    
        const variantData = variant_list.find((variant) => variant.id === variantId);
    
        if (variantData) {
          const button = document.querySelector(`button[data-variant-id="${variantId}"]`);
          let span = button.querySelector('span');
    
          if (button) {
            if (cartQuantity >= variantData.quantity) {
              span.textContent = "Out of Stock!";
            } else {
              span.textContent = cstmAtcBtnName_xx;
            }
          }
        }
      });
    }

    customATC(targetBtn){
        if (targetBtn.matches('.cstm-special-temp-atc') || targetBtn.matches('.cstm-special-temp-atc span')) {

            let variantId = targetBtn.getAttribute('data-variant-id');
            if (targetBtn.matches('.cstm-special-temp-atc')) {
                variantId = targetBtn.getAttribute('data-variant-id');
            }else{
                const spanButtonContainer = targetBtn.closest('.cstm-special-temp-atc');
                variantId = spanButtonContainer.getAttribute('data-variant-id');
            }
            
            const spanSelect = targetBtn.querySelector('span');
            let span = targetBtn.querySelector('span');

            if (targetBtn.matches('.cstm-special-temp-atc span')) {
                span = targetBtn;
            }else{
                span = spanSelect;
            }

            if (variantId) {
                let formData = {
                    'items': [{
                        'id': variantId,
                        'quantity': 1
                    }]
                };

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    // console.log('Item added to cart:', data);

                    span.innerText = 'Added to cart!';
                    setTimeout(() => {
                        this.cartUpdate();
                    }, 2000);

                });
            }

        }
    }

    async checkCartOnLoad() {

        variant_unavailable_list.forEach(item => {
            const outOfStockItem = document.querySelector(`[data-variant-id="${item.id}"] span`); 
            outOfStockItem.innerText = 'Out of stock!'
        });

        const endpoint = window.Shopify.routes.root + 'cart.js';
        try {
            const response = await fetch(endpoint, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }else{
                const data = await response.json();
                data.items.forEach(item => {
                    const outOfStockItem = variant_list.find(variantItem => variantItem.id === item.id);
                    if (outOfStockItem) {
                        if (outOfStockItem.quantity == item.quantity ) {
                            const buttonToUpdate = document.querySelector(`[data-variant-id="${item.id}"] span`); 
                            buttonToUpdate.innerText = 'Out of stock!'
                        }
                    }

                });
            }

        } catch (error) {
            console.error('Error fetching cart data XXX:', error);
        }
    }

}

const clickHandlerV2 = new ClickHandlerV2();
